// extracted by mini-css-extract-plugin
export var button = "_1l-0";
export var buttonContent = "_1l-e";
export var buttonGroup = "_1l-c";
export var dontRestrainIconWidth = "_1l-a";
export var dropdownButton = "_1l-b";
export var iconContainer = "_1l-9";
export var lg = "_1l-4";
export var md = "_1l-3";
export var pending = "_1l-f";
export var sm = "_1l-2";
export var spinner = "_1l-d";
export var squared = "_1l-8";
export var wrapText = "_1l-g";
export var xl = "_1l-5";
export var xs = "_1l-1";
export var xxl = "_1l-6";
export var xxxl = "_1l-7";